import React, { useState, useEffect } from "react";
import ChatModeratorKit from "../../data/ChatModeratorKit";
import CorporateAgentMenu from "./CorporateAgent/CorporateAgentMenu";
import ModeratorMenu from "./ModeratorMenu";
import { ChatTypeEnums } from "../../data/ChatMessageKit";
import VideoMenu from "./VideoMenu";

export default function ChatMessageInputView({
  me,
  isPublic,
  isModerator,
  type,
  createVideoRoom,
  videoBtn,
  userIsMuted,
  handleOnSubmit,
  handleOnChange,
  handleOnPaste,
  message,
  filter,
  setFilter,
  event,
  page,
  messageInput,
  handleOnKeyDown,
  handleOnKeyUp,
  generateMessages,
  handleClearMessage,
  isCorporateAgent,
  urlParams,
  eventUserAvailabilityList,
}) {
  useEffect(() => {
    if (userIsMuted) handleClearMessage();
  }, [userIsMuted]);

  return (
    <div
      className={`col-12 px-0 chat-message-input ${
        type === ChatTypeEnums.CORPORATE && "corporate-chat-input"
      } d-flex align-items-center mt-2 mb-3 ${
        isPublic && isModerator ? "ms-3" : "not-moderator"
      }`}
    >
      {(type === ChatTypeEnums.PRIVATE || type === ChatTypeEnums.CORPORATE) &&
        !isCorporateAgent && (
          <VideoMenu
            onClickVirtualMeetingRoom={createVideoRoom}
          />
        )}

      {type === ChatTypeEnums.CORPORATE && isCorporateAgent && (
        <VideoMenu
          isAgent={true}
          onClickVirtualMeetingRoom={createVideoRoom}
        />
      )}

      <div className="w-100 d-inline-block">
        <fieldset disabled={userIsMuted ? "disabled" : ""}>
          <form
            className={`d-flex rounded p-0 ${userIsMuted ? "inputMuted" : ""} `}
            onSubmit={handleOnSubmit}
            autoComplete="off"
          >
            <div
              ref={messageInput}
              contentEditable={!userIsMuted}
              placeholder={
                userIsMuted ? "Chat Suspended" : "Write your message"
              }
              onInput={handleOnChange}
              onKeyDown={handleOnKeyDown}
              onKeyUp={handleOnKeyUp}
              onPaste={handleOnPaste}
              className="resizeable-input text-break focus-outline-purple"
            ></div>
            <button className="rounded-right submit-button pe-3 focus-outline-purple">
              {!isCorporateAgent ? (
                <img
                  src="/assets/slantedSubmitButton.svg"
                  className="submit-holder"
                  alt=""
                  width="17"
                  height="17"
                />
              ) : (
                <img
                  src="/assets/submitButtonCorporate.svg"
                  className="submit-holder"
                  alt=""
                  width="20"
                  height="18"
                />
              )}
            </button>
          </form>
        </fieldset>
      </div>

      {isModerator && type === ChatTypeEnums.PUBLIC && (
        <div className="d-inline-block mx-2">
          <ModeratorMenu
            filter={filter}
            generateMessages={generateMessages}
            setFilter={setFilter}
            event={event}
            page={page}
            type={type}
          />
        </div>
      )}

      {type === "corporate" && isCorporateAgent && (
        <div className="d-inline-block mx-2">
          <CorporateAgentMenu
            urlParams={urlParams}
            eventUserAvailabilityList={eventUserAvailabilityList}
            me={me}
          />
        </div>
      )}
    </div>
  );
}
